import React from 'react';
import Navbar from '../components/Navbar/Component';
import OrderPage from '../components/OrderPage/Component';
import MoreShopButton from '../components/MoreShopButton/Component';

function Order() {
  return (
   <>
   <Navbar/>
   <OrderPage/>
   <MoreShopButton/>
   </>
  )
}

export default Order
